<template>
  <div class="sticky top-0 bg-white border-b z-10 flex items-center px-4 w-full h-11">
    <label for="search" class="flex-none">
      <img src="@/static/search_btn.svg" alt="搜索" class="w-4 h-4 cursor-pointer" />
    </label>
    <input
      v-model="search"
      type="text"
      id="search"
      class="flex-grow h-full border-0 ring-0 text-sm"
      @input="searchContent"
    />
    <img
      src="@/static/delete_btn.svg"
      alt="清除搜索內容"
      class="w-4 h-4 cursor-pointer flex-none"
      @click="deleteSearch"
      v-if="search"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
export default {
  data() {
    return {
      search: this.$route.query.keywords || "",
      timer: null,
    };
  },
  methods: {
    searchContent: debounce(function () {
      this.$emit("getSearchContent", this.search);
    }, 500),
    deleteSearch() {
      this.search = "";
      this.$emit("getSearchContent", this.search);
    },
  },
};
</script>

<style lang="scss" scoped></style>
